/**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2013-2023 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */

/**
 * @namespace Phaser.Math.Fuzzy
 */

module.exports = {

    Ceil: require('./Ceil'),
    Equal: require('./Equal'),
    Floor: require('./Floor'),
    GreaterThan: require('./GreaterThan'),
    LessThan: require('./LessThan')

};
